import { NewsScreen } from '../features/news/NewsScreen'
import { useShell } from '../app/outlet'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

/** Флаг `VITE_FEATURE_NEWS` выключен — раздела нет, адрес ведёт в «не найдено». */
export function NewsPage() {
  const { toast } = useShell()
  return env.features.news ? <NewsScreen onToast={toast} /> : <NotFoundPage />
}
